//rever preço
import { useState, useEffect } from "react";
import { useValue } from "../../../../providers/ValueContext";
import { useCutChicken } from "../../../../providers/CutChickenContext";
import { useUser } from "../../../../providers/UserContext";
import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import SubHeaderPcp from "../../../../Components/ComponentsIndustry/SubHeaderPcp";
import SalesPredctionCard from "../../../../Components/ComponentsIndustry/SalesPredctionCard";
import InputCardPcp from "../../../../Components/ComponentsIndustry/InputCardPcp";
import { useMachinery } from "../../../../providers/MachineryContext";
import axios from "axios";

import { Container, SizeContainer, ContainerInput } from "./style";

const ToolsPcpCutChicken = () => {
  const { lossesPercentagem, setLossesPercentagem } = useValue();

  const { infoCutChicken, setInfoCutChicken, insumosCutChicken, getCutChickenStock } = useCutChicken();
  const { maquinaFrangoCorte } = useMachinery()

  let [cutChickenPrevSales, setCutChickenPrevSales] = useState(0);
  let [cutChickenStock, setCutChickenStock] = useState(0);
  let [costUnit, setCostUnit] = useState(0);
  let [cutChickenPrevProductions, setCutChickenPrevProductions] = useState(0);
  let [cutChickenProductRecipe, setCutChickenProductRecipe] = useState(0);
  let [priceUnit, setPriceUnit] = useState(0);

  const { user, rodada, industry } = useUser()

  function handlePcp() {

    // const storagedUser = JSON.parse(localStorage.getItem('@App:user'));

    // const data = {
    //   "custoUnitario": costUnit,
    //   "industria": {
    //     "industria": storagedUser.industria.industria,
    //   },
    //   "planejamentoProducao": cutChickenProductRecipe,
    //   "previsaoPerda": 3,
    //   "previsaoProducao": cutChickenPrevProductions,
    //   "previsaoVenda": cutChickenPrevSales,
    //   "produto": {
    //     "produto": 9,
    //   },
    //   "rodada": 1,
    //   "usuario": {
    //     "usuario": storagedUser.usuario
    //   }
    // }

    const data = {
      "custoUnitario": costUnit,
      "industria": {
        industria: industry?.industria
      },
      "planejamentoProducao": cutChickenProductRecipe,
      "previsaoPerda": lossesPercentagem,
      "previsaoProducao": cutChickenPrevProductions,
      "previsaoVenda": cutChickenPrevSales,
      "produto": {
        "produto": 9,
      },
      "rodada": rodada,
      "usuario": user
    }

    axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/cadastrar", data)
      .then(response => fetchPCP())
      .catch(error => console.log(error))

  }

  useEffect(() => {
    if (!industry?.industria) return
    setLossesPercentagem(3 - industry?.funcControleQualidade ?? 0)
  }, [industry])

  useEffect(() => {

    setCutChickenStock(infoCutChicken.estoque)

    setCostUnit(
      infoCutChicken.custoUnitario
    );

    setPriceUnit(
      infoCutChicken.preco
    );

    setCutChickenPrevProductions(
      parseFloat((cutChickenPrevSales - cutChickenStock) * ((100 - lossesPercentagem) / 100) < 0 ? 0 : Math.round((cutChickenPrevSales - cutChickenStock) * ((100 - lossesPercentagem) / 100))).toFixed(2)
    );

    setCutChickenProductRecipe(
      parseFloat(cutChickenPrevSales * priceUnit.toFixed(2))
    );



    // setInfoCutChicken({
    //   previsaoVendas: cutChickenPrevSales,
    //   estoque: cutChickenStock,
    //   previsaoProducao: cutChickenPrevProductions,
    //   custoUnitario: costUnit,
    //   receitaProduto: cutChickenProductRecipe,
    //   pesoCaixa: infoCutChicken.pesoCaixa,
    // });
  }, [
    setInfoCutChicken,
    setCutChickenPrevProductions,
    lossesPercentagem,
    cutChickenPrevSales,
    cutChickenStock,
    cutChickenPrevProductions,
    costUnit,
    cutChickenProductRecipe,
    rodada
  ]);

  const fetchPCP = async () => {
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterPCP/${industry?.industria}/${rodada?.rodada}/9`)
      .then((response) => {
        if (response.data.previsaoVenda) {
          setCutChickenPrevSales(response.data.previsaoVenda)
        }
      })
  }

  useEffect(() => {
    if (!rodada?.rodada) return
    fetchPCP()
  }, [rodada])

  useEffect(() => {

    getCutChickenStock()

  })

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/pcp_button.svg"
          title="PCP"
          subTitle="(Planejamento Controle de Produção)"
          style={["selection", "", "", "", ""]}
        />

        <SubHeaderPcp
          style={["", "", "selection", "", ""]}
          product="Frango Corte"
          unity="Caixa de 1 Kg"
        />

        {maquinaFrangoCorte.amount >= 1 ? (
          <>
            <ContainerInput>
              {insumosCutChicken?.map((insumo, key) => {
                let imageURL = null
                if (insumo.insumo.nome === "Frango P") {
                  imageURL = "./images/chicken_p.svg"
                } else if (insumo.insumo.nome === "Caixa (Papelão)") {
                  imageURL = "./images/box.svg"
                } else if (insumo.insumo.nome === "Pernil Suíno") {
                  imageURL = "./images/pig.svg"
                }
                return (
                  <InputCardPcp
                    path={imageURL ?? insumo.insumo.urlImagem}
                    title={insumo.insumo.nome}
                    value={`${insumo.quantidade}`}
                  />
                )
              })}
              {/* <InputCardPcp
            path="./images/chicken.svg"
            title="Frango L"
            value="3,7KG"
          />
          <InputCardPcp
            path="./images/box.svg"
            title="Caixa (papelão)"
            value="1 uni."
          />
          <InputCardPcp
            path="./images/carry_bag.svg"
            title="Embalagem Plástica"
            value="1 milh."
          /> */}
            </ContainerInput>

            <SalesPredctionCard
              state1={cutChickenStock}
              setState1={setCutChickenStock}
              state2={cutChickenPrevProductions}
              setState2={setCutChickenPrevProductions}
              state3={cutChickenPrevSales}
              setState3={setCutChickenPrevSales}
              state4={costUnit}
              setState4={setCostUnit}
              state5={priceUnit}
              total={cutChickenProductRecipe}
              setTotal={setCutChickenProductRecipe}
            />

            <FooterButton text="Confirmar" path="/toolsPcpFries" onHandle={() => handlePcp()} />
          </>
        ) : (
          <ContainerInput style={{ color: "white", padding: 20, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div>ADQUIRA O MAQUINÁRIO PARA PRODUZIR ESTE PRODUTO</div>
          </ContainerInput>
        )}


      </SizeContainer>
    </Container>
  );
};
export default ToolsPcpCutChicken;
